import React from "react";

const Hero = () => {
  return (
    <>
      <header className="" id="home">
        <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="mr-auto place-self-center py-24 px-4 lg:py-0 lg:col-span-7">
            <h1 className="max-w-2xl mb-4 text-4xl text-indigo-500 font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl">
              Build your dream website today
            </h1>
            <p className="max-w-2xl mb-6 font-light lg:mb-8 md:text-lg lg:text-xl">
              Need a website to make your business stand out.
            </p>
            <div className="flex flex-col md:flex-row gap-4">
              <a
                href="#about"
                aria-label="about"
                rel="noopener"
                className="inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-lg bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:ring-indigo-300"
              >
                Contact Me
                <svg
                  className="w-5 h-5 ml-2 -mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href="#contact"
                aria-label="get a qoute"
                rel="noopener"
                className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-indigo-400 border border-zinc-400 rounded-lg hover:bg-zinc-800 focus:ring-4 focus:ring-indigo-100"
              >
                Get a Qoute
              </a>
            </div>
          </div>
          <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              width="920.10876"
              height="411.95215"
              viewBox="0 0 920.10876 411.95215"
            >
              <path
                d="M576.47229,654.02393H772.06284c7.72143,0,7.73422-12,0-12H576.47229c-7.72143,0-7.73422,12,0,12Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#e6e6e6"
              />
              <path
                d="M523.66535,393.25494H328.73176a7.77658,7.77658,0,0,0-7.76706,7.76724v38.72531C330.68844,439.97637,337,448,338.5294,457.74056v35.10668h.73832a.44433.44433,0,0,1,.44307.443v18.6806a.44433.44433,0,0,1-.44307.443h-.73832V625.32342c0,2.48077-.02488,7.00673-.02488,7.00673H523.66535a7.77669,7.77669,0,0,0,7.76723-7.76719V401.02218A7.77674,7.77674,0,0,0,523.66535,393.25494Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#6c63ff"
              />
              <path
                d="M885.84519,265.83414V477.73451H544.91447V384.43929a15.9929,15.9929,0,0,0-15.97754-15.97744H464.998V265.83414Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#6c63ff"
              />
              <path
                d="M906.895,507.60731H545.29517v-1.47665H905.4183V256.57552a11.08751,11.08751,0,0,0-11.07494-11.07494H452.0844a11.08751,11.08751,0,0,0-11.07493,11.07494V367.50509h-1.47666V256.57552a12.56574,12.56574,0,0,1,12.55159-12.55159h442.259A12.56573,12.56573,0,0,1,906.895,256.57552Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M872.63242,552.64537H545.29517v-1.47666H872.63242A32.82279,32.82279,0,0,0,905.4183,518.383V507.60731H545.29517v-1.47665H906.895V518.383A34.30125,34.30125,0,0,1,872.63242,552.64537Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M775.48478,625.00174c-18.24788-17.52212-30.252-40.38444-34.11085-72.35637H606.8847c-1.36825,29.91173-13.296,52.34479-34.8127,72.2775l-2.27343.07914c22.19931-20.11831,34.42669-42.71583,35.641-73.12453l.0283-.70877h137.2192l.07607.65289c3.78995,32.51355,16.04535,55.52328,34.74289,73.06176Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M528.58,655.54815H321.40678v-1.47666H528.58a15.995,15.995,0,0,0,15.97681-15.97682V384.77831A15.99478,15.99478,0,0,0,528.58,368.8015H321.40678a15.99476,15.99476,0,0,0-15.97672,15.97681v54.66734H303.9534V384.77831a17.47323,17.47323,0,0,1,17.45338-17.45347H528.58a17.47324,17.47324,0,0,1,17.45347,17.45347V638.09467A17.47325,17.47325,0,0,1,528.58,655.54815Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M424.99336,386.00664A5.00664,5.00664,0,1,1,430,380.99986,5.01247,5.01247,0,0,1,424.99336,386.00664Zm0-8.856a3.84938,3.84938,0,1,0,3.84938,3.84924A3.85374,3.85374,0,0,0,424.99336,377.15062Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M424.99336,649.88845a6.38845,6.38845,0,1,1,6.38846-6.38863A6.39589,6.39589,0,0,1,424.99336,649.88845Zm0-11.30025a4.9118,4.9118,0,1,0,4.9118,4.91162A4.91736,4.91736,0,0,0,424.99336,638.5882Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M319.32627,655.97607h-68.58A19.49526,19.49526,0,0,1,231.273,636.50265V458.91871a19.49517,19.49517,0,0,1,19.47315-19.47306h68.58022a19.49512,19.49512,0,0,1,19.47315,19.47306v31.7795a1.923,1.923,0,0,1,1.18167,1.77228l-.00009,20.67825a1.92291,1.92291,0,0,1-1.18158,1.77228V636.503A19.49531,19.49531,0,0,1,319.32627,655.97607ZM250.74614,440.9223a18.017,18.017,0,0,0-17.9965,17.99641V636.50265a18.017,18.017,0,0,0,17.99659,17.99677h68.58A18.01708,18.01708,0,0,0,337.32285,636.503V513.59181h.73833a.44357.44357,0,0,0,.44325-.44307l.00009-20.67825a.444.444,0,0,0-.44334-.44343h-.73833V458.91871a18.017,18.017,0,0,0-17.99649-17.99641Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M320.08225,445.05807h-8.952a6.64707,6.64707,0,0,1-6.15429,9.1575H265.68732a6.64709,6.64709,0,0,1-6.15429-9.15752h-8.36116a13.991,13.991,0,0,0-13.991,13.99095V636.37252a13.991,13.991,0,0,0,13.991,13.991h68.9104a13.991,13.991,0,0,0,13.991-13.991h0V459.049A13.991,13.991,0,0,0,320.08225,445.05807Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#6c63ff"
              />
              <path
                d="M1059.17526,655.6871H140.82474a.87912.87912,0,1,1,0-1.75823h918.35052a.87912.87912,0,1,1,0,1.75823Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M775.94091,655.27308H571.42365a15.50491,15.50491,0,1,1,0-31.00981H775.94091a15.50491,15.50491,0,0,1,0,31.00981ZM571.42365,625.73992a14.02825,14.02825,0,0,0,0,28.0565H775.94091a14.02825,14.02825,0,0,0,0-28.0565Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <polygon
                points="784.495 293.196 790.223 305.172 839.14 288.778 830.686 271.103 784.495 293.196"
                fill="#ffb8b8"
              />
              <path
                d="M907.50437,547.25409h41.721a0,0,0,0,1,0,0v16.1195a0,0,0,0,1,0,0H922.39123a14.88686,14.88686,0,0,1-14.88686-14.88686v-1.23264A0,0,0,0,1,907.50437,547.25409Z"
                transform="translate(688.03055 1388.39573) rotate(-115.5616)"
                fill="#2f2e41"
              />
              <polygon
                points="772.964 400.141 786.231 399.693 786.789 348.049 771.237 348.967 772.964 400.141"
                fill="#ffb8b8"
              />
              <path
                d="M910.19853,639.76179h41.721a0,0,0,0,1,0,0v16.1195a0,0,0,0,1,0,0H925.08538a14.88686,14.88686,0,0,1-14.88686-14.88686v-1.23264A0,0,0,0,1,910.19853,639.76179Z"
                transform="translate(1722.17248 1051.61914) rotate(180)"
                fill="#2f2e41"
              />
              <path
                d="M914.00089,636.40674a4.974,4.974,0,0,1-4.83032-3.78613c-7.26782-29.20118-34.31128-176.333-10.397-205.23l.20849-.252.31641-.08008c1.67895-.4248,33.325-10.22265,51.8938,5.0708l.21728.17872,10.33423,29.915,27.85864,41.3545a20.40321,20.40321,0,0,1-6.033,28.65381l-36.58227,23.08544a5.00875,5.00875,0,0,1-5.75293-.40527,5.06054,5.06054,0,0,1-1.50025-2.0918l-7.688-19.21972a5.02952,5.02952,0,0,1,2.40649-6.3291l17.1394-8.56983a3.67422,3.67422,0,0,0,1.83008-2.5039,2.95853,2.95853,0,0,0-1.029-2.543l-19.89575-17.15137a2.99979,2.99979,0,0,0-4.95654,2.38525l4.93212,130.20264a5.00239,5.00239,0,0,1-4.21679,5.12793L914.8,636.34326A5.04875,5.04875,0,0,1,914.00089,636.40674Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#2f2e41"
              />
              <path
                d="M948.32194,437.43652q-.1692,0-.3396-.01269l-49.616-3.67529a4.49311,4.49311,0,0,1-3.91406-5.97022A47.09244,47.09244,0,0,0,895.52823,400.46c-3.23169-12.7417-3.30786-36.4331-3.06591-49.4209a8.75319,8.75319,0,0,1,8.28125-8.522l.00024-.01758,1,.01221c8.08252.11328,22.91553.68994,35.05322,3.21533a18.38913,18.38913,0,0,1,14.65918,17.69971c.2749,12.0581.31543,28.37939-1.053,37.65722-1.15429,7.82715.978,22.8584,2.35157,31.12159a4.49779,4.49779,0,0,1-4.43286,5.23095Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M966.03451,484.73417a10.02474,10.02474,0,0,1-3.81052-14.892L939.3082,371.02393H956.633l20.22438,96.87052a10.07912,10.07912,0,0,1-10.82286,16.83972Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#ffb8b8"
              />
              <path
                d="M857.50412,381.72872l27.43545-25.95245,10.33581,14.47014L869.43585,392.9852,903.323,419.89553c.24477-.01653.48853-.03722.73784-.03722a10.85257,10.85257,0,1,1-10.74561,12.296l-.107.107-35.2694-30.56682A13.47074,13.47074,0,0,1,857.50412,381.72872Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#ffb8b8"
              />
              <path
                d="M941.1337,377.3559a4.47022,4.47022,0,0,1-4.05249-2.55371,52.813,52.813,0,0,1-4.46777-14.57031c-1.18994-8.24414,4.54248-13.14844,10.37207-14.2168,5.67065-1.03955,12.57764,1.45361,14.34326,9.38281a20.4515,20.4515,0,0,1,.34229,2.03223c.70678,6.01074,1.37207,10.68555,1.97729,13.89551a4.49484,4.49484,0,0,1-4.19849,5.32031l-14.08618.7041Q941.24833,377.35591,941.1337,377.3559Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <circle cx="781.54395" cy="59.98149" r="30" fill="#2f2e41" />
              <circle
                cx="781.72505"
                cy="67.76889"
                r="24.56103"
                fill="#ffb8b8"
              />
              <path
                d="M878.07755,365.40288a4.47023,4.47023,0,0,1-1.26223-4.62071,52.813,52.813,0,0,1,6.55053-13.76029c4.69282-6.88181,12.23248-6.62434,17.25206-3.47326,4.88294,3.06494,8.2905,9.56962,4.23488,16.6082a20.45263,20.45263,0,0,1-1.12072,1.72948c-3.54,4.90884-6.20806,8.80474-7.93065,11.58013a4.49483,4.49483,0,0,1-6.68988,1.08563l-10.86048-8.99812Q878.16205,365.48032,878.07755,365.40288Z"
                transform="translate(-139.94562 -244.02393)"
                fill="#3f3d56"
              />
              <path
                d="M915.66229,277.21285c-6.03677-3.602-7.34375-12.57182-3.74723-18.61186s10.86483-9.19077,17.89148-9.39843c10.037-.29663,19.7303,4.70092,26.75606,11.875s11.66158,16.35735,15.19438,25.75674,6.06848,19.148,9.54978,28.5666c1.78642,4.8331,3.98607,9.79571,8.07262,12.93423s10.58267,3.70466,14.0761-.083c-.01315,6.0611-4.6599,11.57084-10.42318,13.44744s-12.28286.45949-17.33524-2.88871c-8.76483-5.80843-12.99675-16.41134-15.41565-26.64409s-3.61026-20.9553-8.47365-30.27773c-2.015-3.86257-4.77616-7.53174-8.66146-9.50262s-9.06133-1.84146-12.18669,1.19368c-1.44761,1.40582-2.385,3.32275-4.02776,4.49463a8.04651,8.04651,0,0,1-7.03634.73265,23.801,23.801,0,0,1-6.36213-3.59"
                transform="translate(-139.94562 -244.02393)"
                fill="#2f2e41"
              />
              <path
                d="M896.02042,295.19761a29.38292,29.38292,0,0,0,42.12117,5.2576c2.3848-1.94028,4.5998-4.61419,4.45022-7.68494-.15322-3.14529-2.72407-5.61565-5.349-7.35527a34.48446,34.48446,0,0,0-23.40409-5.3776c-4.675.62823-9.36382,2.33216-12.67459,5.69216s-4.96042,8.58574-3.25265,12.98281"
                transform="translate(-139.94562 -244.02393)"
                fill="#2f2e41"
              />
            </svg>
          </div>
        </div>
      </header>
    </>
  );
};

export default Hero;
